"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactWebcam = _interopRequireDefault(require("react-webcam"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var WebcamPictureField =
/*#__PURE__*/
function (_Component) {
  _inherits(WebcamPictureField, _Component);

  function WebcamPictureField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, WebcamPictureField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WebcamPictureField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      countdown: 0,
      isWaiting: false,
      intervalId: null
    };

    _this.setRef = function (webcam) {
      _this.webcam = webcam;
    };

    _this.getScreenshot = function () {
      var onChange = _this.props.onChange;

      var data = _this.webcam.getScreenshot();

      onChange(data);
    };

    _this.takePicture = function () {
      if (_this.state.isWaiting) return;
      var _this$props = _this.props,
          delay = _this$props.delay,
          value = _this$props.value,
          onChange = _this$props.onChange;

      if (delay === 0) {
        _this.getScreenshot();

        return;
      } // reset image value if exists


      if (value) onChange(null); // create interval for countdown

      var intervalId = setInterval(_this.timer, 100);

      _this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          isWaiting: true,
          countdown: delay,
          intervalId: intervalId
        });
      });
    };

    _this.timer = function () {
      if (_this.state.countdown <= 0) {
        clearInterval(_this.state.intervalId);

        _this.setState(function (prevState) {
          return _objectSpread({}, prevState, {
            isWaiting: false,
            countdown: 0,
            intervalId: null
          });
        });

        _this.getScreenshot();
      } else _this.setState(function (prevState) {
        return _objectSpread({}, prevState, {
          countdown: prevState.countdown - 100
        });
      });
    };

    return _this;
  }

  _createClass(WebcamPictureField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          delay = _this$props2.delay,
          otherProps = _objectWithoutProperties(_this$props2, ["value", "delay"]);

      var _this$state = this.state,
          countdown = _this$state.countdown,
          isWaiting = _this$state.isWaiting;

      var webcamProps = _objectSpread({
        videoConstraints: {
          width: otherProps.width,
          height: otherProps.height,
          facingMode: 'user'
        }
      }, otherProps);

      return _react.default.createElement("div", null, value ? _react.default.createElement("img", {
        alt: "screenshot",
        src: value
      }) : _react.default.createElement(_reactWebcam.default, Object.assign({}, webcamProps, {
        ref: this.setRef
      })), isWaiting && _react.default.createElement("span", null, Math.ceil(countdown / 1000)));
    }
  }]);

  return WebcamPictureField;
}(_react.Component);

WebcamPictureField.defaultProps = {
  onChange: function onChange() {},
  value: null,
  delay: 3000,
  width: 640,
  height: 480,
  audio: false,
  screenshotQuality: 1
};
var _default = WebcamPictureField;
exports.default = _default;